import { User } from '@tassomutuo-backoffice/types';

export type ImpersonationMode = 'admin' | 'team' | 'group' | null;

export const getImpersonationMode = (user: User | null): ImpersonationMode => {
  if (user?.role === 'admin') return 'admin';
  if (user?.team) return 'team';
  if (user?.ledGroups?.length) return 'group';
  return null;
};
